import React from 'react';
import { gikClassPrefix } from '@gik/core/constants';
import classnames from 'classnames';
import { BaseBoneProps } from '@gik/ui/SkeletonLoader/Bones/BaseBone';
import ParagraphBone from '@gik/ui/SkeletonLoader/Bones/ParagraphBone';
import { Button, IButtonProps } from '@gik/ui';
import { useRandomInt } from '@gik/core/utils/getRandomInt';

const blockName = `${gikClassPrefix}-button-bone`;

export type ButtonBoneBoneProps = BaseBoneProps &
  Pick<IButtonProps, 'size' | 'squared' | 'circle' | 'pill' | 'rounded' | 'wide'> & {
    words?: number;
  };

export default function ButtonBone({ className, words, ...buttonProps }: ButtonBoneBoneProps) {
  const blockClasses = classnames([blockName, className || '']);
  const randomDelta = useRandomInt(1, 2);

  return (
    <Button className={blockClasses} variant="default-outline" disabled {...buttonProps}>
      <ParagraphBone words={words ? words : randomDelta} />
    </Button>
  );
}
